import { f as i } from "./addOns-5IZhcbHD.js";
const r = {
  id: "FloridaPick2",
  name: "Pick 2",
  style: {
    colorPrimary: "#e74360",
    fireball: i
  }
};
export {
  r as default
};
